import styled from 'styled-components';
import { KOGTableRow } from '@/main/components/shared/boxGrid/styles';
import { IconButton } from '@mui/material';
import SecondaryButton from '@/main/components/shared/button/secondaryButton';

export const Container = styled(KOGTableRow)`
  &&& {
    .MuiIconButton-root.Mui-disabled {
      color: rgba(0, 0, 0, 0.34);
    }
    .TableCell-Status,
    .TableCell-SizeActions {
      width: 120px;
    }
    .TableCell-SizeActions {
      padding-top: 0px;
      padding-bottom: 0px;
    }
    .TableCell-SizeSmall {
      max-width: 250px;
      min-width: 250px;
      width: 250px;
    }
    .TableCell-SizeMedium {
      width: 50%;
    }
  }
`;

interface ICustomColumn {
  $width?: string;
}
export const CustomColumn = styled.div<ICustomColumn>`
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const LabelErrors = styled.span`
  font-size: 1rem;
  text-align: left;
`;

export const IconButtonCustom = styled(IconButton)<{ $isSelected?: boolean }>`
  &&& {
    border-radius: 5px;
    padding: 5px;
  }
`;

export const ErrorLogButton = styled(SecondaryButton)`
  background-color: transparent;
  border-color: ${props => props.theme.errorDark};
  color: ${props => props.theme.errorDark};
  padding: 0.1rem 0.1rem;
  min-width: 135px;
`;

export const ColumnLink = styled.div`
  width: 100%;
  max-width: auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #3f5ec9;

  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;